import { FC, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MainInfo, RequestDetails } from './components';
import { Spinner } from '@components';
import { getDOTrainingRequestDetails } from '@/common/api/digitalOffice';
import { getTrainingStatuses } from '@/common/api/trainings';
import { anonymizePerson } from './utils';

interface ITrainingRequestDetail {
  requestId: string | number;
}

export const TrainingRequestDetail: FC<ITrainingRequestDetail> = ({ requestId }) => {
  const [isDataAnonymized, setIsDataAnonymized] = useState(false);

  const { isFetching, data } = useQuery({
    queryKey: ['do-training-request-detail', requestId],
    queryFn: async () => {
      const res = await getDOTrainingRequestDetails(requestId);

      const focalPoint = anonymizePerson(res.focal_point);
      const supervisor = anonymizePerson(res.supervisor);

      const isAnonymized = focalPoint?.is_anonymized === true || supervisor?.is_anonymized === true;

      setIsDataAnonymized(isAnonymized);

      return {
        ...res,
        focal_point: focalPoint,
        supervisor: supervisor,
      };
    },
  });

  const { isLoading: statusLoading, data: statuses = [] } = useQuery({
    queryKey: ['training-statuses'],
    queryFn: getTrainingStatuses,
  });
  const isLoading = statusLoading || isFetching;

  return (
    <div className="w-full">
      {isLoading && <Spinner fullScreen />}
      {data ? (
        <>
          <MainInfo trainingRequest={data} statuses={statuses} />
          {/*Separator*/}
          <div className="pb-5" />
          <RequestDetails
            trainingRequest={data}
            statuses={statuses}
            isDataAnonymized={isDataAnonymized}
          />
          <div className="pb-5" />
        </>
      ) : null}
    </div>
  );
};

export default TrainingRequestDetail;
